// Classes.
import { BaseComponentLocator } from './base.component-locator';

// Interfaces.
import { ComponentLocatorInterface } from '../interfaces/component-locator.interface';


export type SortingType = "date" | "noc" | "level";

export class SortingLocatorComponent extends BaseComponentLocator implements ComponentLocatorInterface {


  protected validSortings: SortingType[] = [];
  protected _sortingType: SortingType = "date";
  protected _orderAsc = false;


  public constructor(protected _value: SortingType = "date") {
    super();
  };

  public toString(): string {
    return this._sortingType + '-' + (this._orderAsc ? 'asc' : 'desc');
  }

  public setValidSortings(validSortings: SortingType[]) {
    this.validSortings = validSortings;
  }

  protected isValid(sortingType: SortingType) {
    return this.validSortings.indexOf(sortingType) !== -1;
  }

  /**
   * value setter/getter.
   */
  set sortingType(sortingType: SortingType) {
    //if (this.isValid(sortingType)) {
    this._sortingType = sortingType;
    // }
    // else {
    //   throw new RangeError('Invalid sorting type');
    // }
  }

  get sortingType(): SortingType {
    return this._sortingType;
  }

  set asc(isAsc: boolean) {
    this._orderAsc = isAsc;
  }

  get asc(): boolean {
    return this._orderAsc;
  }

}

